import {
  ButtonIcon,
  Col,
  Row,
  Tooltip,
} from '@cubeyou-team/hx-react-components';
import theme from '@cubeyou-team/hx-theme';
import { connect } from 'react-redux';
import React from 'react';

import { sendEvent } from '../../actions';
import { StyledRepositoryItemActions } from './StyledRepositoryItemActions';
import RepositoryItemMoreActions from './components/RepositoryItemMoreActions';

const RepositoryItemActions = ({
  item,
  showMoreActions,
  onMoreActionClick,
  actions,
  sendEvent,
}) => {
  const { persistence, metadata } = item;
  if (!actions) {
    return null;
  }
  const isTemporary = persistence === 'temporary';
  const isReady = metadata?.status === 'ready';
  const isCampaign = item?.campaign;

  return (
    <StyledRepositoryItemActions isCampaign={isCampaign}>
      <Row gutter="none">
        {isReady && !isCampaign && (
          <Col>
            <Tooltip content="Save" position="top">
              <ButtonIcon
                size="small"
                data-test="save-button"
                data-test-is-permanent={!isTemporary}
                icon={isTemporary ? 'star_outline' : 'star'}
                variant={!isTemporary ? 'warning' : 'dark'}
                onClick={e => {
                  e.stopPropagation();
                  actions.save(item);
                  sendEvent('Workspace');
                }}
                disabled={!isReady || !isTemporary}
                customDisabledColor={theme.colors.warning}
              />
            </Tooltip>
          </Col>
        )}
        <Col span="auto">
          <RepositoryItemMoreActions
            item={item}
            show={showMoreActions}
            onMoreActionClick={onMoreActionClick}
            actions={actions}
          />
        </Col>
      </Row>
    </StyledRepositoryItemActions>
  );
};

const mapDispatchToProps = {
  sendEvent,
};

export default connect(null, mapDispatchToProps)(RepositoryItemActions);
